;(function(){

	$('.js-reveal').each(function() {

		$(this).cleverScroll({
				offset: site.height / 8,
				onEnterViewport: function($el) {
					$el.addClass('active');
				},
			});
	});

}());
